export const ADD_MICROS_OUTLET_DIALOG_NAME = 'addMicrosOutlet';
export const EDIT_MICROS_OUTLET_DIALOG_NAME = 'editMicrosOutlet';
export const DELETE_MICROS_OUTLET_DIALOG_NAME = 'deleteMicrosOutlet';
